import styled from "styled-components";

export const MainDiv = styled.div`
  padding: 16px;
  width: 100%;
  max-width: 930px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  gap: 20px;
`;
export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const SectionTitle = styled.p`
  margin: ${({ margin }) => margin && margin};
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
`;
export const CloseImg = styled.img`
  width: 30px;
  height: 30px;
`;
export const ClinicalDataDiv = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  background: rgba(242, 242, 242, 0.95);
`;
export const LegendsDiv = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const LegendDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const LegendColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100px;
  background: ${({ background }) => background && background};
`;
export const SectionText = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;
export const StatusDiv = styled.div`
  margin: ${({ margin }) => margin && margin};
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ background }) => background && background};
  gap: 4px;
`;
export const StatusText = styled.p`
  color: #fff;
  font-size: 10px;
  font-weight: 600;
`;
export const StatusImg = styled.img`
  width: 12px;
  height: 12px;
`;
export const PlotsDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const PlotDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;
